import type { TaskTrackerBoardFilterStickerRow } from '../store/taskTracker.types'
import { isTaskTrackerSystemStickerFieldType } from './taskTrackerBoard.stickerFilters.utils'
import {
  buildTaskTrackerColumnSortStickerValue,
  type TaskTrackerColumnSortOption,
} from './taskTrackerColumnSort.utils'
import type { TaskTrackerSummarySortingConfig } from './taskTrackerBoardSummary.types'

export type BoardSummarySortingDraftRow = {
  id: string
  sortBy: string
  sortOrder: 'asc' | 'desc'
}

export const TASK_TRACKER_SUMMARY_SORT_SYSTEM_OPTIONS = [
  { value: 'position', label: 'Порядок на доске' },
  { value: 'id', label: 'ID задачи' },
  { value: 'title', label: 'Название' },
  { value: 'deadline', label: 'Дедлайн' },
  { value: 'is_completed', label: 'Выполнена' },
  { value: 'creator_id', label: 'Автор' },
  { value: 'board_id', label: 'Доска' },
  { value: 'column_id', label: 'Столбец' },
  { value: 'performers', label: 'Исполнители' },
] as const

let boardSummarySortingRowIdCounter = 0

export const createBoardSummarySortingRowId = () => {
  boardSummarySortingRowIdCounter += 1
  return `board-summary-sort-${boardSummarySortingRowIdCounter}`
}

export const createEmptyBoardSummarySortingRow = (): BoardSummarySortingDraftRow => ({
  id: createBoardSummarySortingRowId(),
  sortBy: 'deadline',
  sortOrder: 'asc',
})

export const buildTaskTrackerSummarySortOptions = (
  stickers: TaskTrackerBoardFilterStickerRow[] = [],
): TaskTrackerColumnSortOption[] => {
  const stickerOptions = stickers
    .filter(
      (sticker) => !isTaskTrackerSystemStickerFieldType(sticker.fieldType),
    )
    .map((sticker) => ({
      value: buildTaskTrackerColumnSortStickerValue(sticker.fieldSettingId),
      label: sticker.title,
    }))

  return [...TASK_TRACKER_SUMMARY_SORT_SYSTEM_OPTIONS, ...stickerOptions]
}

export const mapSortingConfigToDraftRows = (
  sortingConfig: TaskTrackerSummarySortingConfig[],
): BoardSummarySortingDraftRow[] => {
  if (!sortingConfig.length) return []

  return sortingConfig
    .filter((item) => String(item.sortBy ?? '').trim())
    .map((item) => ({
      id: createBoardSummarySortingRowId(),
      sortBy: String(item.sortBy),
      sortOrder: item.sortOrder === 'desc' ? 'desc' : 'asc',
    }))
}

export const mapDraftRowsToSortingConfig = (
  rows: BoardSummarySortingDraftRow[],
): TaskTrackerSummarySortingConfig[] =>
  rows
    .filter((row) => String(row.sortBy ?? '').trim())
    .map((row) => ({
      sortBy: row.sortBy,
      sortOrder: row.sortOrder,
    }))
